// src/views/Client/ClientLayout.js

import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  HomeIcon,
  ChatBubbleLeftEllipsisIcon,
  UserCircleIcon,
  DocumentTextIcon,
  WrenchScrewdriverIcon,
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { UserProvider, useUser } from '../../context/UserContext'; // 👈 importar aquí

// ✅ ENVOLVEMOS el layout con el Provider
const ClientLayout = () => {
  return (
    <UserProvider>
      <LayoutWithUser />
    </UserProvider>
  );
};

// ✅ Layout original separado como componente interno
const LayoutWithUser = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { clientProfile } = useUser(); // ✅ Ahora sí funciona

  const navItems = [
    { to: 'dashboard', label: 'Panel', icon: HomeIcon },
    { to: 'invoices', label: 'Facturas', icon: DocumentTextIcon },
    { to: 'messages', label: 'Mensajes', icon: ChatBubbleLeftEllipsisIcon },
    { to: 'service', label: 'Servicio', icon: WrenchScrewdriverIcon },
    { to: 'profile', label: 'Perfil', icon: UserCircleIcon },
  ];

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gray-50">

      {/* Topbar móvil */}
      <div className="md:hidden flex items-center justify-between px-4 py-3 bg-white border-b">
        <div className="flex items-center gap-3">
          <img src="/logo-prwd.svg" alt="Puerto Rico Windows & Doors" className="w-20" />
          {clientProfile?.profileImageUrl && (
            <img
              src={clientProfile.profileImageUrl}
              alt="Avatar"
              className="w-10 h-10 rounded-full object-cover border border-gray-300"
            />
          )}
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? (
            <XMarkIcon className="h-6 w-6 text-gray-700" />
          ) : (
            <Bars3Icon className="h-6 w-6 text-gray-700" />
          )}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`bg-white w-full md:w-64 border-r shadow-sm md:block ${
          sidebarOpen ? 'block' : 'hidden'
        }`}
      >
        <div className="p-4 flex flex-col items-center">

          <img
            src="/logo-prwd.svg"
            alt="Puerto Rico Windows & Doors"
            className="w-28 mb-4"
          />

          {clientProfile && (
            <div className="mb-6 text-center">
              <img
                src={clientProfile.profileImageUrl || '/default-avatar.png'}
                alt="Avatar"
                className="w-20 h-20 rounded-full object-cover border-2 border-gray-300 mx-auto mb-2"
              />
              <p className="text-sm font-medium text-gray-800">
                {clientProfile.businessName || 'Cliente'}
              </p>
              <p className="text-xs text-gray-500 break-all">{clientProfile.email}</p>
            </div>
          )}

          <nav className="space-y-2 w-full">
            {navItems.map((item) => (
              <NavItem key={item.to} {...item} />
            ))}
          </nav>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 p-4 space-y-6">
        <div className="overflow-x-auto flex gap-3 py-2 px-1">
          {navItems.map((item) => (
            <TabLink key={item.to} {...item} />
          ))}
        </div>
        <Outlet />
      </main>
    </div>
  );
};

const NavItem = ({ to, label, icon: Icon }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 py-2 rounded text-sm font-medium transition ${
        isActive
          ? 'bg-blue-100 text-blue-700'
          : 'text-gray-700 hover:bg-gray-100'
      }`
    }
  >
    <Icon className="h-5 w-5" />
    <span>{label}</span>
  </NavLink>
);

const TabLink = ({ to, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `whitespace-nowrap px-4 py-2 rounded-full border transition text-sm font-medium ${
        isActive
          ? 'bg-blue-600 text-white border-blue-600 shadow'
          : 'bg-gray-100 text-gray-700 border-transparent hover:bg-blue-100'
      }`
    }
  >
    {label}
  </NavLink>
);

export default ClientLayout;
